import React, {useEffect, useMemo, useRef, useState} from "react"
import {useAppDispatch, useAppSelector} from "../../../../../hooks/redux"
import {IFetchOrdersParams} from "../../../../../models/order"
import {fetchDriverOrdersNew, fetchDriverOrdersCurrent, fetchDriverOrdersCompleted} from "../../../../../store/actions/orderActions"
import DriverOrderLine from "../DriverOrderLine"
import Loading from "../../../Loading/Loading"
import ModalSuccess from "../../../modals/ModalSuccess/ModalSuccess"
import classes from "./DriverOrderList.module.scss"
import Button from "../../../../generic/buttons/Button"

interface IDriverOrderListProps {
  type: "new" | "current" | "complete"
}

function DriverOrderList({type}: IDriverOrderListProps) {

  const dispatch = useAppDispatch()
  const {list, isLoading, totalCount} = useAppSelector(state => state.order)
  const [modalAcceptShown, modalAcceptToggle] = useState(false)
  const [modalFinishShown, modalFinishToggle] = useState(false)

  const fetchParams = useMemo(() => {
    const obj: IFetchOrdersParams = {}
    obj.page = 1
    obj.pageSize = 0
    return obj
  }, [])

  let emptyMessage = ""

  const modalAccept = modalAcceptShown && <ModalSuccess
    close={() => modalAcceptToggle(false)}
    title={"Заявка принята!"}
  />

  const modalFinish = modalFinishShown && <ModalSuccess
    close={() => modalFinishToggle(false)}
    title={"Заявка завершена!"}
  />

  const getOrderList = async (type: string) => {
    switch (type) {
      case "new":
        await dispatch(fetchDriverOrdersNew(fetchParams))
        emptyMessageText.current = "Новые заявки отсутствуют"
        break
      case "current":
        await dispatch(fetchDriverOrdersCurrent(fetchParams))
        emptyMessageText.current = "Нет принятых заявок"
        break
      case "complete":
        await dispatch(fetchDriverOrdersCompleted(fetchParams))
        emptyMessageText.current = "Нет завершенных заявок"
        break
    }
  }

  const emptyMessageText = useRef("")

  useEffect(() => {
     getOrderList(type)
  }, [
    dispatch,
    fetchParams,
    type,
    emptyMessage
  ])

  const orderLines = useMemo(() => {
    return list.map(order =>
      <DriverOrderLine
        key={order.id}
        order={order}
        acceptOrderSuccess={modalAcceptToggle}
        finishOrderSuccess={modalFinishToggle}
      />
    )
  }, [list])

  const emptyTemplate = !isLoading && totalCount === 0  &&
    <div className={classes.empty}>
      <div className={classes.empty_text}>
        {emptyMessageText.current}
      </div>
    </div>

  return (
    <div className={classes.wrap}>
      <div className={classes.button_refresh_wrap}>
        <Button
          className={classes.button_refresh}
          color={`white`}
          icon={`refresh`}
          onClick={() => getOrderList(type)}
        >Обновить список заявок</Button>
      </div>
      {isLoading && <Loading className={classes.loading}/>}
      {!isLoading && totalCount > 0 && orderLines}
      {emptyTemplate}
      {modalAccept}
      {modalFinish}
    </div>
  )
}

export default DriverOrderList